import { HTMLAttributes, memo } from 'react';
import { cn } from '@/lib/utils';

export interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
  variant?: 'text' | 'circular' | 'rectangular';
  width?: string | number;
  height?: string | number;
}

/**
 * Skeleton (memoized) - Placeholder de carga con estilos Tailwind Plus
 * 
 * Mejoras aplicadas:
 * - Dark mode: bg-white/5 semi-transparente
 * - Animación mejorada
 */
const variantClasses = {
  text: 'rounded h-4',
  circular: 'rounded-full',
  rectangular: 'rounded-lg',
};

export const Skeleton = memo(function Skeleton({ variant = 'text', width, height, className = '', ...props }: SkeletonProps) {
  const style: React.CSSProperties = {};
  if (width) style.width = typeof width === 'number' ? `${width}px` : width;
  if (height) style.height = typeof height === 'number' ? `${height}px` : height;

  return (
    <div
      className={cn(
        'animate-pulse',
        // Light mode
        'bg-secondary-100',
        // Dark mode - Tailwind Plus style
        'dark:bg-white/5',
        variantClasses[variant],
        className
      )}
      style={style}
      {...props}
    />
  );
});
